import { cn as e } from "../../shared/utils.js";
import { Button as t } from "../../button/primitive/button.js";
import { useTranslation as n } from "../../i18n/hooks.js";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { useMediaQuery as a } from "@systemeio/util";
//#region src/date-picker/primitive/actions.tsx
function o({ applyDisabled: o, className: s, clearDisabled: c, onApply: l, onClear: u }) {
	let { t: d } = n(), { isMobile: f } = a();
	return /* @__PURE__ */ i("div", {
		className: e("flex gap-1", s),
		children: [/* @__PURE__ */ r(t, {
			variant: "secondary",
			size: f ? "md" : "sm",
			className: "flex-1",
			disabled: c,
			onClick: u,
			children: d("public_pages_purchase.date_picker.clear")
		}), /* @__PURE__ */ r(t, {
			variant: "primary",
			size: f ? "md" : "sm",
			className: "flex-1",
			disabled: o,
			onClick: l,
			children: d("public_pages_purchase.date_picker.apply")
		})]
	});
}
//#endregion
export { o as Actions };
